import { NgIf, AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { ParagraphComponent } from '@spartacus/storefront'

@Component({
  selector: 'eb-about-us',
  templateUrl: './eb-about-us.component.html',
  imports: [NgIf, AsyncPipe]
})
export class EbAboutUsComponent extends ParagraphComponent {}
